import { FormatRegistry } from '@sinclair/typebox';
/**
 * TypeBox treats an UNREGISTERED `format` as a failed check rather than
 * ignoring it, so a schema carrying `format: 'email'` rejects every value
 * until the format is registered here. Fastify validates with ajv, which has
 * its own format support - registering these keeps the two engines agreeing
 * instead of the API accepting input the unit tests reject.
 *
 * Imported for its side effect by `primitives.ts`, so any consumer of this
 * package gets the registrations without having to know they exist.
 */
const EMAIL = /^[^@\s]+@[^@\s.]+(\.[^@\s.]+)+$/;
const DATE_TIME = /^\d{4}-\d{2}-\d{2}[Tt]\d{2}:\d{2}:\d{2}(\.\d+)?([Zz]|[+-]\d{2}:\d{2})$/;
function register(name, test) {
    if (!FormatRegistry.Has(name))
        FormatRegistry.Set(name, test);
}
register('email', (value) => EMAIL.test(value));
register('date-time', (value) => DATE_TIME.test(value) && !Number.isNaN(Date.parse(value)));
//# sourceMappingURL=formats.js.map